module.exports = __webpack_public_path__ + "static/media/25488531_1703509669724217_8642055219930663092_o.02a977ee.jpg";